import classes from "./Section3.module.css";
import { useNavigate } from "react-router-dom";

export default function Section3() {
  const navigate = useNavigate();

  return (
    <section className={classes.section3Wrapper}>
      {/* Overlay */}
      <div className={classes.overlay}></div>

      <div className={classes.content}>
        <h2>High-Quality Refurbished IT Hardware</h2>

        <p>
          Prime Cloud Systems provides premium refurbished hardware and
          multi-vendor components. Perfect for IT maintenance, service, and
          system integration, our solutions deliver performance, reliability,
          and value.
        </p>

        <button
          className={classes.ctaButton}
          onClick={() => navigate("/contact-us")}
          aria-label="Contact Prime Cloud Systems for IT hardware solutions"
        >
          Get in Touch
        </button>
      </div>
    </section>
  );
}
